import { Form, Typography, VertButton, VertLoading, VertRadio, VertSelect, VertTypography, notification } from '@vertem-core/vertice-ds';
import React, { useEffect, useMemo, useState } from 'react';
import 'Assets/styles/default/pages/concierge/NewConciergeSolicitationStyles.less';
import "Assets/styles/default/components/Concierge/Components/ClientInformation.less";
import PropTypes from 'prop-types';
import { Col, Row } from 'antd';
import { useDispatch, useSelector } from 'react-redux';
import { getRequestTypeThunk } from 'redux/Reducers/Concierge/requestTypeSlicer';
import { getPointsThunk } from 'redux/Reducers/Concierge/getPointsSlicer';
import { getClientHierarchyThunk } from 'redux/Reducers/Concierge/clientHierarchySlicer';
import { useNavigate } from 'react-router';
import ReturnConciergeListConfirmationModal from '../Modals/ReturnConciergeListConfirmationModal';
import ErrorApiModal from '../Modals/ErrorApiModal';
import { pointsMask } from 'Utils/commons/points';
import { validateGroupThunk } from 'redux/Reducers/Concierge/validateGroupSlice';
import { CategoryTypeEnum } from 'pages/ManageConciergeSolicitationPage/enum/action-enum';
import { LuArrowRight } from 'react-icons/lu';

const ClientInformation = ({ ...props }) => {
    const {
        solicitation,
        setSolicitation,
        setUserPoints,
        handleNextStep,
        setFlowSteps,
    } = props;

    const [form] = Form.useForm();
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const userProfile = useSelector((state) => state?.oidc.user.profile);
    const [clientSearchDebounce, setClientSearchDebounce] = useState(null);
    const [requestTypeList, setRequestTypeList] = useState([]);
    const [clientList, setClientList] = useState([]);
    const [selectedClient, setSelectedClient] = useState();

    const [isOpenReturnConciergeList, setIsOpenReturnConciergeList] = useState(false);
    const [isOpenModalErrorApi, setIsOpenModalErrorApi] = useState(false);
    const Catalog = useSelector(({ Catalog: data }) => data);
    const { currencyConfiguration: { decimalPlaces, pointsName } } = Catalog;

    const {
        cpfCnpj
    } = useSelector(
        (state) => state.Participants
    );

    const {
        dataRequestType,
        loadingRequestType,
        errorRequestType
    } = useSelector(
        (state) => state.RequestType
    );

    const {
        dataClientHierarchy,
        loadingClientHierarchy
    } = useSelector(
        (state) => state.ClientHierarchy
    );

    const {
        dataGetPoints,
        loadingGetPoints,
        errorGetPoints,
    } = useSelector(
        (state) => state.GetPoints
    );

    const {
        loadingGroupValidation,
        groupValidationError,
    } = useSelector(
        (state) => state.ValidateGroup
    );

    const handleRequestType = (requestType) => {
        setSelectedClient(null);

        const loggedUserId = userProfile["custom:client_id"];
        const loggedUserDocument = cpfCnpj.value;

        setSolicitation((solicitation) => {
            const isQuote = requestType.isQuote;
            const isConcierge = requestType.isConcierge;
            const isHierarchy = requestType.isHierarchy;

            return {
                ...solicitation,
                type: requestType.type,
                isQuote,
                isConcierge,
                isHierarchy,
                requestTypeId: requestType.id,
                isBillPayment: requestType.type === CategoryTypeEnum.BillPayment,
                requestTypeFlowId: requestType.flowId,
                clientId: (isQuote && isHierarchy) ? null : loggedUserId,
                clientDocument: (isConcierge && isHierarchy) ? null : loggedUserDocument,
                productList: [],
            }
        });

        setFlowSteps(requestType.registerSteps);
    }

    const searchClientHierarchy = (term) => {
        if (clientSearchDebounce) clearInterval(clientSearchDebounce);

        if (!term) {
            dispatch(getClientHierarchyThunk());
            setClientSearchDebounce(null);
            return;
        }

        const timeoutId = setTimeout(() => {
            dispatch(getClientHierarchyThunk(term));
        }, 500);

        setClientSearchDebounce(timeoutId);
    }

    const filterClientHierarchy = (input, option) => {
        return option.label.toLowerCase().indexOf(input.toLowerCase()) >= 0;
    }

    const handleClientHierarchySelect = (selectedClient) => {
        const client = clientList.find(client => client.value === selectedClient.value);

        setSelectedClient(client);

        setSolicitation((solicitation) => ({
            ...solicitation,
            clientId: client.id,
            participantId: client.participantId,
            clientDocument: client.document,
            clientName: client.name,
            clientLogin: client.login
        }));

        dispatch(getPointsThunk({ participantId: client.participantId, login: client.login }));
        dispatch(validateGroupThunk({ participantId: client.participantId, flowId: solicitation.requestTypeFlowId }));
    }

    const continueStep = () => {
        handleNextStep(solicitation);
    }

    const disableContinueButton = () => {
        if (!solicitation.isHierarchy && !solicitation.isQuote && !solicitation.isBillPayment) return true;
        if (solicitation.isHierarchy && !solicitation.clientId) return true;

        if (loadingGetPoints || errorGetPoints) return true;
        if (loadingGroupValidation || groupValidationError) return true;

        return false;
    }

    useMemo(() => {
        if (!dataClientHierarchy) return setClientList([]);

        return setClientList(dataClientHierarchy.map(client => {
            return {
                id: client.id,
                participantId: client.participantId,
                login: client.login,
                name: client.name,
                document: client.document,
                label: client.label,
                value: client.id,
            }
        }))
    }, [dataClientHierarchy]);

    useEffect(() => {
        dispatch(getRequestTypeThunk());

        if (solicitation.participantId && solicitation.clientDocument) {
            const participantId = solicitation.participantId;
            const login = solicitation.clientLogin;

            dispatch(getPointsThunk({ participantId, login }));
        }
    }, []);

    useEffect(() => {
        if (errorRequestType)
            setIsOpenModalErrorApi(true);
    }, [errorRequestType]);

    useEffect(() => {
        if (dataRequestType.length)
            setRequestTypeList(dataRequestType);
    }, [dataRequestType]);

    useEffect(() => {
        if (dataGetPoints) 
            setUserPoints(dataGetPoints);
    }, [dataGetPoints]);

    useEffect(() => {
        if (groupValidationError)
            notification.error({
                message: "Cliente não pertence ao grupo."
            });
    }, [groupValidationError])

    useEffect(() => {
        if (!solicitation.clientId) return;

        const selectedClient = clientList.find(client => client.id === solicitation.clientId);
        setSelectedClient(selectedClient);
    }, [])

    return (

        <Form form={form}>

            {!errorRequestType &&
                <>
                    {loadingRequestType ?
                        <VertLoading className='loading-space' />
                        :
                        <Row className='container-concierge-information-main' >

                            <Col span={24}>
                                <Typography.Text className='text-subtitle'>
                                    Qual tipo de solicitação você gostaria de fazer?
                                </Typography.Text>
                            </Col>

                            <Col span={24} className='text-request-title'>
                                <Typography.Text>
                                    Escolha abaixo o tipo de solicitação que deseja realizar:
                                </Typography.Text>
                            </Col>

                            <Row gutter={[8, 8]} className='radio-group-request-type'>
                                {
                                    requestTypeList.map(requestType => (
                                        <Col key={requestType.id} span={24} onClick={() => handleRequestType(requestType)}                                >
                                            <div className={`radio-request-type ${solicitation.requestTypeId == requestType.id ? 'radio-selected' : ''}`}>
                                                <Form.Item noStyle>
                                                    <VertRadio checked={solicitation.requestTypeId == requestType.id}>
                                                        {requestType.name}
                                                    </VertRadio>
                                                </Form.Item>
                                            </div>
                                        </Col>
                                    ))
                                }
                            </Row>

                            {
                                (solicitation.isQuote && solicitation.isHierarchy) &&

                                <Row gutter={[16, 16]} className='container-client-information-sub'>

                                    <Col span={24}>
                                        <Typography.Text className='text-subtitle'>
                                            Informações sobre o cliente
                                        </Typography.Text>
                                    </Col>

                                    <Col span={24} className='text-request-title'>
                                        <Typography.Text>
                                            Busque ou selecione o cliente para continuar com a solicitação de resgate:
                                        </Typography.Text>
                                    </Col>

                                    <Col span={24}>
                                        <Form.Item>
                                            <VertSelect
                                                showSearch
                                                className='customer-search'
                                                placeholder='Razão social / CNPJ'
                                                items={clientList}
                                                onFocus={e => searchClientHierarchy(e.target.value)}
                                                onSearch={searchClientHierarchy}
                                                filterOption={filterClientHierarchy}
                                                onSelect={(_, client) => handleClientHierarchySelect(client)}
                                                value={selectedClient}
                                                loading={loadingClientHierarchy}
                                                notFoundContent={
                                                    <VertTypography.Text>
                                                        { loadingClientHierarchy ? "Carregando..." : "Sem resultados" }
                                                    </VertTypography.Text>
                                                }
                                            />
                                        </Form.Item>
                                    </Col>

                                    {solicitation.clientId &&
                                        <Col span={24}>
                                            <Row>
                                                <Col span={16}>
                                                    <Row>
                                                        <Col span={24}>
                                                            <Typography.Text className='text-subtitle'>
                                                                Saldo do cliente
                                                            </Typography.Text>
                                                        </Col>
                                                        <Col span={24} className='text-group-balance'>
                                                            
                                                            <Typography.Text>
                                                                {loadingGetPoints 
                                                                    ? "Carregando..."
                                                                    : `${pointsMask(dataGetPoints.pointsValue, decimalPlaces, pointsName).value} ${pointsName}`
                                                                }
                                                            </Typography.Text>
                                                        </Col>
                                                    </Row>
                                                </Col>
                                            </Row>
                                        </Col>
                                    }
                                </Row>
                            }
                        </Row >
                    }
                </>
            }

            <Row className="btn-group" gutter={[8, 8]} justify={'end'}>
                <Col>
                    <VertButton
                        className='button-continue button-concierge'
                        type='default'
                        size="default"
                        onClick={() => setIsOpenReturnConciergeList(true)}
                    >
                        <Typography.Text className='span-button-return'>
                            Voltar
                        </Typography.Text>

                    </VertButton>
                </Col>
                <Col>
                    <VertButton
                        className='button-continue button-concierge'
                        type='highlight'
                        size="default"
                        disabled={disableContinueButton()}
                        onClick={continueStep}
                        loading={loadingGroupValidation || loadingGetPoints}
                    >
                        <Typography.Text className='span-button-continue'>
                            Continuar
                        </Typography.Text>

                        <LuArrowRight  />

                    </VertButton>
                </Col>
            </Row>
            <ReturnConciergeListConfirmationModal
                isOpen={isOpenReturnConciergeList}
                onClose={() => setIsOpenReturnConciergeList(false)}
                goToList={() => navigate("/list-solicitations")}
            />
            <ErrorApiModal
                isOpen={isOpenModalErrorApi}
                onClose={() => navigate("/list-solicitations")}
            />
        </Form >
    )
}

ClientInformation.propTypes = {
    solicitation: PropTypes.object.isRequired,
    setSolicitation: PropTypes.func.isRequired,
    userPoints: PropTypes.number.isRequired,
    setUserPoints: PropTypes.func.isRequired,
    handleNextStep: PropTypes.func.isRequired,
    setFlowSteps: PropTypes.func.isRequired,
};

export default ClientInformation;
